import React from "react";

function Header() {
  return (
    <header className="uk-margin-medium-bottom uk-text-center">
      <h1 className="uk-heading-line uk-margin-small">LOGIKK</h1>
      <sub className="uk-text-meta">Logical Expression Visualiser</sub>
    </header>
  );
}

export default Header;
